import React from 'react';

const formatDateTime = (value) => {
  if (!value) {
    return '-';
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }

  return date.toLocaleString('en-GB', {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
};

const PeopleVisitCard = ({ data }) => {
  const { slug, title, people_visited, visit_datetime } = data || {};

  return (
    <div className='relative overflow-hidden rounded-2xl border border-[#D4DEF1] bg-white shadow-custom'>
      <div className='h-1 w-full bg-gradient-to-r from-[#1C1C1C] via-[#506DFF] to-[#D9DCF8]' />
      <div className='p-3.5'>
        <div className='flex items-start justify-between gap-2'>
          <div className='min-w-0'>
            <p className='text-[0.6rem] uppercase tracking-[0.24em] text-[#7D8CA7]'>People Visit</p>
            <h3 className='mt-1.5 truncate text-[0.95rem] font-MluvkaBold capitalize text-[#1C1C1C]'>
              {title || slug || '-'}
            </h3>
          </div>
         
        </div>
         <span className='whitespace-nowrap text-wrap rounded-full bg-[#E8F7EE] px-2.5 py-0.5 text-[0.65rem] text-[#12804D]'>
            {slug || '-'}
          </span>

        <div className='mt-3 grid grid-cols-2 gap-2 max-sm:grid-cols-1'>
          <div className='rounded-xl bg-[#EFF4FD] p-3'>
            <div className='text-[0.6rem] uppercase tracking-[0.18em] text-[#7D8CA7]'>People visited</div>
            <div className='mt-1.5 text-[1.5rem] leading-none font-MluvkaBold text-secondary'>
              {people_visited ?? '-'}
            </div>
          </div>
          <div className='rounded-xl bg-[#F8FAFC] p-3'>
            <div className='text-[0.6rem] uppercase tracking-[0.18em] text-[#7D8CA7]'>Visit datetime</div>
            <div className='mt-1.5 text-[0.8rem] leading-[1.35] font-Mluvka text-[#393946]'>
              {formatDateTime(visit_datetime)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PeopleVisitCard;
